import { Component, Input, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import '@maersk-global/mds-components-core/mc-popover';
import '@maersk-global/mds-components-core/mc-tag';

import '@maersk-global/mds-components-core/mc-popover';

@Component({
  selector: 'app-overflow-list',
  imports: [],
  templateUrl: './overflow-list.component.html',
  styleUrl: './overflow-list.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class OverflowListComponent {
  @Input() items: string[] = [];
  @Input() maxVisible = 2;
  @Input() useTags = false;

  showPopover = false;

  get visibleItems(): string[] {
    return this.items.slice(0, this.maxVisible);
  }

  get hiddenItems(): string[] {
    return this.items.slice(this.maxVisible);
  }
  get remainingCount(): number {
    return this.items.length - this.maxVisible;
  }
}
